import React from 'react'
import {Col, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

import sfmPicture from './../resources/img/sfm.jpg'

const Sfm = props  => {
    let { main } = props
    return (
       <div className={'bg-white border-bottom-yellow'}>
            <Helmet>
                <title>{'SFM  - '+main.get.main.name}</title>
            </Helmet>
            <div className={'container p-5 text-center'}>
                <Row>
                    <Col>
                        <img alt={"sfm"} src={sfmPicture} />
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Sfm;
